import React, { useState } from "react";
import { FiMenu } from "react-icons/fi";
import { AiFillHome, AiFillSignal } from "react-icons/ai";
import { BiUserPlus } from "react-icons/bi";
import { IoNotificationsCircleSharp } from "react-icons/io5";
import { Link } from "react-router-dom";
import "./Menu.css";

const Menu = () => {
	const [isMenuOpen, setIsMenuOpen] = useState(false);

	const toggleMenu = () => {
		setIsMenuOpen(!isMenuOpen);
	};

	return (
		<div>
			<button className='menu-icon2' onClick={toggleMenu}>
				<FiMenu />
			</button>

			{isMenuOpen && (
				<div className='menu-options2'>
					<Link style={{ textDecoration: "none" }} to='/inicio'>
						<div className='button-index-left2'>
							<AiFillHome className='icon-button-left2' />
							<p className='text-button-left-in2'>Home</p>
						</div>
					</Link>

					<Link style={{ textDecoration: "none" }} to='/informe'>
						<div className='button-index-left2'>
							<AiFillSignal className='icon-button-left2' />
							<p className='text-button-left-in2'>Informe</p>
						</div>
					</Link>

					<Link style={{ textDecoration: "none" }} to='/detailMDR'>
						<div className='button-index-left2'>
							<AiFillSignal className='icon-button-left2' />
							<p className='text-button-left2'>Matriz de Riesgo</p>
						</div>
					</Link>

					<Link
						style={{ textDecoration: "none" }}
						to='/crear_usuaruis'
					>
						<div className='button-index-left2'>
							<BiUserPlus className='icon-button-left2' />
							<p className='text-button-left2'>
								Crear <br /> Relación
							</p>
						</div>
					</Link>

					<Link style={{ textDecoration: "none" }} to='/alertas'>
						<div className='button-index-left2'>
							<IoNotificationsCircleSharp className='icon-button-left2' />
							<p className='text-button-left2'>Alertas</p>
						</div>
					</Link>
				</div>
			)}
		</div>
	);
};

export default Menu;